import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import './EDNLPage.css';

import SourcesTab from './tabs/SourcesTab';
import OntologyTab from './tabs/OntologyTab';
import TemplatesTab from './tabs/TemplatesTab';
import PatternsTab from './tabs/PatternsTab';
import FramesTab from './tabs/FramesTab';
import BridgeTab from './tabs/BridgeTab';
import AuditTab from './tabs/AuditTab';
import LiveStreamTab from './tabs/LiveStreamTab';
import WorkspacePicker from './WorkspacePicker';
import {
  getEdnlWorkspaceId,
  isUuidString,
  setEdnlWorkspaceId,
} from './workspaceUtils';
import { apiService } from '../../services/api';

const TABS = [
  { id: 'sources',   label: 'Sources' },
  { id: 'ontology',  label: 'Ontology' },
  { id: 'templates', label: 'Templates' },
  { id: 'patterns',  label: 'Patterns' },
  { id: 'frames',    label: 'Frames' },
  { id: 'bridge',    label: 'Bridge' },
  { id: 'audit',     label: 'Audit' },
  { id: 'live',      label: 'Live Stream' },
];

const TAB_COMPONENTS = {
  sources:   SourcesTab,
  ontology:  OntologyTab,
  templates: TemplatesTab,
  patterns:  PatternsTab,
  frames:    FramesTab,
  bridge:    BridgeTab,
  audit:     AuditTab,
  live:      LiveStreamTab,
};

export default function EDNLPage() {
  const location = useLocation();
  const initialTab = (() => {
    const params = new URLSearchParams(location.search);
    const t = params.get('tab');
    return t && TAB_COMPONENTS[t] ? t : 'sources';
  })();
  const [activeTab, setActiveTab] = useState(initialTab);
  const [workspaces, setWorkspaces] = useState([]);
  const [pickerLoading, setPickerLoading] = useState(true);
  const [workspaceId, setWorkspaceId] = useState(() => {
    const stored = getEdnlWorkspaceId();
    return isUuidString(stored) ? stored : '';
  });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const resp = await apiService.getWorkspacesForDropdown();
        if (cancelled) return;
        const list = (resp && resp.workspaces) || [];
        setWorkspaces(list);
        if (!workspaceId && list.length > 0) {
          const next = list[0];
          setWorkspaceId(next.workspaceId);
          setEdnlWorkspaceId(next.workspaceId, next.workspaceName);
        }
      } catch (err) {
        console.error('EDNLPage: failed to load workspaces', err);
      } finally {
        if (!cancelled) setPickerLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handlePick = (id) => {
    setWorkspaceId(id);
    const w = workspaces.find((x) => x.workspaceId === id);
    setEdnlWorkspaceId(id, w?.workspaceName);
  };

  const workspaceName =
    workspaces.find((w) => w.workspaceId === workspaceId)?.workspaceName || null;

  const ActiveComponent = TAB_COMPONENTS[activeTab];

  return (
    <div className="user-home-layout__page">
      <div className="user-home-layout__page-header">
        <h1 className="user-home-layout__page-title">EDNL</h1>
        <p className="user-home-layout__page-subtitle">
          Enterprise Data as Natural Language — live transactional data to engine process maps
        </p>
      </div>

      <WorkspacePicker
        workspaces={workspaces}
        value={workspaceId}
        loading={pickerLoading}
        onChange={handlePick}
      />

      <div className="ednl-tabs">
        {TABS.map((tab) => (
          <button
            key={tab.id}
            className={`ednl-tabs__btn ${activeTab === tab.id ? 'ednl-tabs__btn--active' : ''}`}
            onClick={() => {
              setActiveTab(tab.id);
              const url = new URL(window.location);
              url.searchParams.set('tab', tab.id);
              window.history.replaceState(null, '', url);
            }}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <ActiveComponent workspaceId={workspaceId} workspaceName={workspaceName} />
    </div>
  );
}
